












































































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import SpecialProjectAdd from './specialProjectAdd.vue'
@Component({
    name:'specialProjectList',
    components: {
        SpecialProjectAdd
    }
})
export default class SpecialProjectList extends AbpBase  {
    initData:any = {
        searchInfo: {
            ProjectName: null,
            ProjectLeaderName: null,
            BeginDt:null,
            EndDt:null,
            MinContractAmount:null,
            MaxContractAmount:null
        },
        dicData: {
            allDictionary: {},
            userList:[]
        },
        tableData: {
            title: [
                {
                    title: '项目编号',
                    key: '',
                    width: 100,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.contractCode)
                        ])
                    }    
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    minWidth: 450,
                    align: 'left',
                    className: 'font-blue',
                    render: (h:any,params:any) => {
                        return h('a',{
                            on:{
                                click: ()=> {
                                    this.ToDetail(params.row);
                                }
                            }
                        },params.row.projectName)
                    }
                },
                {
                    title: '合同金额（万元）',
                    key: 'majorField',
                    width: 300,
                    align: 'center',
                    ellipsis: true,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.contract ? params.row.contract.contractAmount : '')
                        ])
                    }  
                },
                {
                    title: '合同起止时间',
                    key: 'beginDt',
                    width: 250,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        let beginDt:any = '',
                            endDt:any = '';
                        if(params.row.contract){
                            beginDt = new Date(params.row.contract.beginDt).getFullYear()+'年'+(new Date(params.row.contract.beginDt).getMonth()+1)+'月'+new Date(params.row.contract.beginDt).getDate()+'日';
                            endDt = new Date(params.row.contract.endDt).getFullYear()+'年'+(new Date(params.row.contract.endDt).getMonth()+1)+'月'+new Date(params.row.contract.endDt).getDate()+'日';
                        }
                        return h('Row', [
                            h('Col', {}, params.row.contract? beginDt+'至'+endDt : '')
                        ])
                    }    
                },
                {
                    title: '项目负责人',
                    key: 'projectLeader',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.projectLeader ? params.row.projectLeader.name : '')
                        ])
                    }  
                },
                {
                    title: '联系电话',
                    key: 'projectLeader',
                    width: 150,
                    align: 'center',                        
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.projectLeader ? params.row.projectLeader.phoneNumber : '')
                        ])
                    }  
                },
                {
                    title: '备注',
                    key: 'projectPeriod',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.projectPeriod ? params.row.projectPeriod+'个月' : '')
                        ])
                    }   
                },
                
            ],
            content: [],
            loading: true,
            totalCount: 0,
            currentIndex:2,
        },
        modalData: {
            status: false,
            loading: true
        }
    }
    //项目填报状态
    Add(type:boolean) {
        // this.initData.modalData.status = type;
        (this as any).reloadComponent('specialProjectAdd');
        this.$nextTick( ()=>{
            this.$router.push({
                name:'specialProjectAdd'
            })
        } ) 
    }
    //重置月份弹窗loading
    resetMonthLoading() {
        setTimeout(() => {
            this.initData.modalData.loading = false;
            this.$nextTick(() => {
                this.initData.modalData.loading = true;
            });
        }, 1000);
    }
    //重置弹窗
    ResetForm(type:any) {
        if(!type){
            (this as any).$refs.SpecialProjectAdd.ResetForm();
        }
    }
    //状态过滤
    Filter(type:any) {
        this.initData.tableData.currentIndex = type;
        this.initData.searchInfo.AuditStatus = type;
        this.GetData();
    }
    //项目提交
    Submit() {
        (this as any).$refs.SpecialProjectAdd.Submit('add');
    }
    //跳转详情
    ToDetail(e:any) {
        (this as any).reloadComponent('specialProjectDetail');
        this.$nextTick( () => {
            this.$router.push({
                name: 'specialProjectDetail',
                query: {
                    id: e.id
                }
            })
        } )  
    }
    //获取表格数据
    async GetData() {
        let temp = (await Ajax.get('/api/services/app/ResearchProject/GetCXProjectByPageAsync', {params: this.initData.searchInfo})).data.result;
        if(!temp.pageResult.items.length) this.$Message.error('暂无数据');
        //格式化
        this.initData.tableData.content = temp.pageResult.items;
        this.initData.tableData.statistic = temp.statistic;
        this.initData.tableData.totalCount = temp.pageResult.totalCount;
        //加载
        this.initData.tableData.loading = false;
    }
    //提交搜索数据
    Search() {
        this.GetData();
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchInfo.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchInfo.MaxResultCount = perPage;
        this.GetData()
    }
    async mounted() {
        await this.GetData();
        //获取所有用户数据
        await this.$store.dispatch('project/GetAllUser');
        this.initData.dicData.userList = this.$store.state.project.userList;
    }
}
